import React from 'react';
import { CallBar } from './CallBar';
import { IncomingCallCard } from './IncomingCallCard';
import { Dialpad } from './Dialpad';
import { DialerFab } from './DialerFab';

/**
 * PhoneRoot — mounts all global call surfaces once. Placed inside
 * <PhoneProvider> in the app shell so they float above every page.
 * Each child self-hides when there's nothing to show.
 */
export const PhoneRoot: React.FC = () => (
  <>
    <IncomingCallCard />
    <CallBar />
    <DialerFab />
    <Dialpad />
  </>
);
